<template>
  <el-card>
    <el-page-header @back="goBack" :content="'文档：' + docName" />
    <!-- 表单 -->
    <div class="top">
      <div class="searchForm"></div>
    </div>
    <!-- 列表 -->
    <el-table :data="list">
      <el-table-column label="分块编号" prop="serial_num" width="150"></el-table-column>
      <el-table-column label="分块内容" prop="content">
        <template slot-scope="scope">
          <a @click="showContent(scope.row)" class="content-link">
            {{ scope.row.content }}
          </a>
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="status" width="150">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 'pending'" type="info">待处理</el-tag>
          <el-tag v-if="scope.row.status === 'processing'" type="primary">处理中</el-tag>
          <el-tag v-if="scope.row.status === 'completed'" type="success">已完成</el-tag>
          <el-tag v-if="scope.row.status === 'failed'" type="danger">处理失败</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="是否启用" prop="enabled" width="250">
        <template slot-scope="scope">
          <el-switch
            :disabled="!jurisdiction.documentsSegments_agent_switch"
            v-model="scope.row.enabled"
            @change="
              (v) => {
                onChangeEnable(scope.row, v);
              }
            "
          ></el-switch>
          <span v-if="scope.row.enabled === true" class="switch active">已启用</span>
          <span v-else class="switch inactive">未启用</span>
        </template>
      </el-table-column>
      <el-table-column label="文件处理错误信息" prop="err_msg" width="250"></el-table-column>
    </el-table>
    <!-- 分页器 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    />
    <el-dialog
      :title="'[#' + segmentSerialNum + ']分片内容'"
      :visible.sync="dialogVisible"
      width="800"
      :before-close="handleClose"
      class="content-dialog"
    >
      <span>
        {{ segmentContent }}
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  components: {},
  data() {
    return {
      payload: {
        limit: 10,
        offset: 0,
      },
      // 表格
      loading: false,
      list: [],
      docName: '',
      page: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      segmentContent: '',
      segmentSerialNum: '',
    };
  },
  computed: {
    ...mapGetters('user', ['getElementList']),
    jurisdiction() {
      // this.getElementList
      console.log('%c Line:154 🍷 this.getElementList', 'color:#4fff4B', this.getElementList);
      const jurisdictionArray = ['documentsSegments_agent_switch'];
      const jurisdictionObj = {};
      for (const item of jurisdictionArray) {
        jurisdictionObj[item] = this.getElementList.includes(item);
      }
      // jurisdictionObj
      console.log('%c Line:167 🍷 testjurisdictionObj', 'color:#33a5ff', jurisdictionObj);
      return jurisdictionObj;
    },
    datasetId() {
      return this.$route.query.dataset_id;
    },
  },
  async created() {
    this.getDocInfo();
    this.getList();
  },
  methods: {
    async getDocInfo() {
      try {
        const { document } = await this.$request({
          url: this.$api.getAgentDocument,
          data: {
            id: this.$route.query.document_id,
          },
        });
        this.docName = document.name;
      } catch (e) {
        console.error(e);
        this.$message.error('获取文档数据失败');
      }
    },
    async getList(showLoading = true) {
      this.loading = true;
      this.payload = {
        ...this.payload,
        limit: this.pageSize,
        offset: (this.page - 1) * this.pageSize,
      };
      try {
        const { segments, total_count: total } = await this.$request({
          url: this.$api.listAgentDocumentSegments,
          data: {
            document_id: this.$route.query.document_id,
            ...this.payload,
          },
          showLoading,
        });
        this.list = segments;
        this.total = parseInt(total);
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.list = [];
        this.loading = false;
      }
    },
    // 翻页器
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.getList();
    },
    showContent(row) {
      this.dialogVisible = true;
      this.segmentContent = row.content;
      this.segmentSerialNum = row.serial_num;
    },
    goBack() {
      this.$router.history.go(-1);
    },
    handleClose() {
      this.dialogVisible = false;
    },
    async onChangeEnable(row, enabled) {
      try {
        await this.$request({
          url: this.$api.updateAgentDocumentSegment,
          data: {
            id: row.id,
            segment: {
              enabled,
            },
          },
          showLoading: false,
        });
        this.getList(false);
      } catch (err) {
        this.$message.error(enabled === true ? '启用失败' : '停用失败');
        console.log(err);
        this.getList(false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/element/button.scss';
@import '@/styles/element/table.scss';
@import '@/styles/element/pagination.scss';
.top {
  display: flex;
  .searchForm {
    flex: 1;
  }
}
.app-select {
  width: 120px;
}
.switch {
  font-size: 14px;
  margin-left: 5px;
  font-size: 12px;
  &.active {
    color: #0d7cff;
  }
  &.inactive {
    color: #666;
  }
}
.content-link {
  text-align: left;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  width: 100%;
}
.content-dialog {
  ::v-deep .el-dialog__body {
    padding-top: 0;
  }
}
</style>
